import React from 'react';
import { classnames } from '../../../../../../utils/classnames';
import ItemCardActionButton from '../itemCardActionButton/itemCardActionButton';
import './itemCardActions.css';

export default function ItemCardActions({ status = '', mainAction = null, infosAction = null }) {
    const buttonType = React.useMemo(() => {
        if (status) {
            return status;
        } 
        return infosAction?.type || 'inverted';

    }, [infosAction, status]);

    return (
        <div className={classnames('neo-item-card-actions')}>
            {infosAction && (
                <ItemCardActionButton 
                    onlyIcon 
                    label={infosAction.label} 
                    icon={infosAction.icon} 
                    type={buttonType} 
                    onClick={infosAction.onClick} 
                />
            )}
            {mainAction && (
                <ItemCardActionButton 
                    label={mainAction.label} 
                    onClick={mainAction.onClick} 
                    type={buttonType}
                />
            )}
        </div>
    )
}
